import { onBeforeMount as c, computed as n } from "vue";
import { useGetDerivedNamespace as i } from "./index559.js";
import { useIdInjection as s } from "./index640.js";
import { isClient as p } from "./index599.js";
const u = () => {
  const o = i(), e = s(), t = n(() => `${o.value}-popper-container-${e.prefix}`), r = n(() => `#${t.value}`);
  return {
    id: t,
    selector: r
  };
}, a = (o) => {
  const e = document.createElement("div");
  return e.id = o, document.body.appendChild(e), e;
}, v = () => {
  const { id: o, selector: e } = u();
  return c(() => {
    p && (process.env.NODE_ENV === "test" || !document.body.querySelector(e.value)) && a(o.value);
  }), {
    id: o,
    selector: e
  };
};
export {
  v as usePopperContainer,
  u as usePopperContainerId
};
